<script lang="ts">
  export type AlertItem = { level: 'info' | 'warn' | 'critical'; title: string; detail: string };

  let { alerts = [] }: { alerts?: AlertItem[] } = $props();
</script>

{#if alerts.length > 0}
  <div class="alerts">
    {#each alerts as a, i (i)}
      <div class="alert {a.level}" role="alert">
        <strong>{a.title}</strong>
        <span>{a.detail}</span>
      </div>
    {/each}
  </div>
{/if}

<style>
  .alerts { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 0.85rem; }
  .alert {
    display: flex; flex-wrap: wrap; gap: 0.35rem 0.75rem; align-items: baseline;
    padding: 0.65rem 0.85rem; border-radius: var(--radius-md); font-size: 0.85rem;
    border: 1px solid var(--border);
  }
  .alert strong { font-weight: 700; }
  .alert span { color: var(--text-secondary); }
  .alert.info { background: color-mix(in srgb, var(--info) 12%, var(--bg-surface)); border-color: color-mix(in srgb, var(--info) 35%, var(--border)); }
  .alert.warn { background: color-mix(in srgb, var(--warning) 15%, var(--bg-surface)); border-color: color-mix(in srgb, var(--warning) 40%, var(--border)); }
  .alert.critical { background: color-mix(in srgb, var(--danger) 12%, var(--bg-surface)); border-color: color-mix(in srgb, var(--danger) 35%, var(--border)); }
  .alert.critical strong { color: var(--danger); }
</style>
